/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_MASQUERADER_LIST = gql`
  query GetUsersWithBoxes(
    $options: GetManyOptions
    $filters: UserAndBoxAggFilterInput
  ) {
    getUsersWithBoxes(options: $options, filters: $filters) {
      count
      limit
      skip
      content {
        email
        firstName
        lastName
        fullName
        image
        primaryContactNo
        phoneNumbers {
          number
          type
        }
        emailVerified
        accountStatus
        _box {
          isVIP
          gender
          contentStatus
          description
          deliveryStatus
          createdAt
          costumeID
          band {
            id
            name
          }
          masqID
          paymentStatus
          id
        }
        address {
          addressLine1
          addressLine2
          addressLine3
          city
          country
          state
          zipCode
        }
        id
        role {
          name
          state
          uuid
        }
      }
    }
  }
`;
